import { type AttendanceCellDto } from 'Pages/Attendance/types'

export function isIncompleteAttendanceCell (cell: AttendanceCellDto): boolean {
  return cell.isMissing ||
    cell.isPastDue ||
    cell.cellState === 'PastDue' ||
    (cell.canEdit && cell.cellState === 'Empty')
}
